// Keep reference to prevent unnecessary renders.
const EMPTY_OBJECT = Object.freeze({});
export const getColumnFilters = (state, props)=>{
    const grid = state.grid[props.id];
    return grid?.columnFilters || EMPTY_OBJECT;
};
export const getFilter = (state, props)=>{
    const grid = state.grid[props.id];
    return grid?.filter || '';
};
export const getSort = (state, props)=>{
    const grid = state.grid[props.id];
    return grid?.sort ?? null;
};
export const getPageSize = (state, props)=>{
    const grid = state.grid[props.id];
    return grid?.pageSize ?? null;
};
export const getActivePage = (state, props)=>{
    const grid = state.grid[props.id];
    return grid?.activePage ?? 1;
};
export const getSelectedItemId = (state, props)=>{
    const grid = state.grid[props.id];
    return grid?.selectedItemId ?? null;
};
